import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	message: "",
	status: "",
	isEdit: false,
	user: {
		id: null,
		nome: "",
		sobrenome: "",
		email: "",
		mariana: false,
		brumadinho: false,
		username: "",
		password: "",
		confirmpassword: "",
		selectedGroups: []
	}

};

export default function newuser(state = initialState, action) {
	
	switch (action.type) {
		case "IS_FETCHING":
			return update(state, { isFetching: { $set: action.bool } });
		case "SET_MESSAGE":
			return update(state, { message: { $set: action.message } });
		case "SET_STATUS":
			return update(state, { status: { $set: action.status } });
		case "SET_EDIT":
			return update(state, { isEdit: { $set: action.edit } });
		case "SET_ID":
			return update(state, { user: { 
				id: { $set: action.id } } });
		case "SET_NOME":
			return update(state, { user: { 
				nome: { $set: action.nome }
			} });
		case "SET_SOBRENOME":
			return update(state, { user: { 
				sobrenome: { $set: action.sobrenome }
			} });
		case "SET_EMAIL":
			return update(state, { user: { 
				email: { $set: action.email }
			} });
		case "SET_MARIANA":
			return update(state, { user: { 
				mariana: { $set: action.mariana }
			} });
		case "SET_BRUMADINHO":
			return update(state, { user: { 
				brumadinho: { $set: action.brumadinho }
			} });
		case "SET_USERNAME":
			return update(state, { user: { 
				username: { $set: action.username }
			} });
		case "SET_PASSWORD":
			return update(state, { user: { 
				password: { $set: action.password }
			} });
		case "SET_CONFIRMPASSWORD":
			return update(state, { user: { 
				confirmpassword: { $set: action.confirmpassword }
			} });
		case "SET_NEW_USER_GROUPS":
			return update(state, { user: { 
				selectedGroups: { $set: action.groups }
			} });

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/manageuser/reducer.js